export default __webpack_public_path__ + "static/media/gsuite.39f07610.svg";